/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PropertyStub } from './PropertyStub'

export class FrontEndMigration {
  constructor(json: JSON | any) {
    Object.assign(this as FrontEndMigration, json)
  }

  id?: string
  rev?: string
  /**
   * hard delete (unix epoch in ms) timestamp of the object. Filled automatically when deletePatient is called.
   */
  deletionDate?: number
  name?: string
  startDate?: number
  endDate?: number
  status?: FrontEndMigration.StatusEnum
  logs?: string
  userId?: string
  startKey?: string
  startKeyDocId?: string
  processCount?: number
  /**
   * Extra properties for the fem. Those properties are typed (see class Property)
   */
  properties?: Array<PropertyStub>
}
export namespace FrontEndMigration {
  export type StatusEnum = 'STARTED' | 'PAUSED' | 'ERROR' | 'SUCCESS'
  export const StatusEnum = {
    STARTED: 'STARTED' as StatusEnum,
    PAUSED: 'PAUSED' as StatusEnum,
    ERROR: 'ERROR' as StatusEnum,
    SUCCESS: 'SUCCESS' as StatusEnum,
  }
}
